<template>
  <div class="ins-header-box show-flex-box-r show-flex-center">
    <div class="show-flex-box-c">
      <dl class="workstation-box show-flex-box-r">
        <dt class="show-flex-box-r">
          <strong @click="tabToHome">
            <img
              src="../../assets/common/logo_black_icon.png"
              alt="新华书店"
              draggable="false"
            />
          </strong>
        </dt>
        <dd class="forum-page-list show-flex-box-r">
          <div class="page-list show-flex-box-r">
            <ul class="show-flex-box-r">
              <li
                class="classifacation-font-white show-flex-box-r"
                :class="{
                  'classifacation-font-white-active': curPosition == item.mark
                }"
                v-for="(item, index) in headerClass"
                :key="index"
                @click="tabToJumpSubcategory(item.title)"
              >
                <strong>{{ item.name }}</strong>
              </li>
            </ul>
          </div>
          <div
            class="user-info show-flex-box-r"
            v-if="logined"
            @click="tabToPersonalCenter"
          >
            <span v-if="userInfo && userInfo.avatar">
              <img
                :src="userInfo.avatar"
                alt="新华书店"
                v-if="userInfo.avatar"
                draggable="false"
              />
            </span>
            <h1 class="hide-line1" v-if="userInfo.nickname">
              {{ userInfo.nickname }}
            </h1>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "ins_forum_header_cpn",
  data() {
    return {
      headerClass: [
        { name: "课程", title: "ins_course", mark: "ins" },
        // {'name': '编程创作', 'title': 'scratch', 'mark': ''},
        // {'name': '机构论坛', 'title': 'teacher_forum', 'mark': 'teacherForum'},
        { name: "在线商城", title: "course_store", mark: "store" }
      ],
      agentData: {
        name: "机构管理",
        title: "institutional_management",
        mark: "management"
      },
      routerInfo: "ins_course_home",
      finderStyle: "none",
      logined: false,
      userInfo: {},
      curPosition: "",
      isCourseDetail: "",
      forumType: "",
      scratchUrl: ""
    };
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    },
    listenUserInfo: function() {
      return this.$store.state.user;
    }
  },
  created() {
    this.forumType = this.$route.params.forum_type;
    this.curPosition = this.$route.params.type;
    this.routerInfo = this.$route.params.isCourseDetail;
    this.isGetUserInfo();
  },
  mounted() {
    this.checkAgent();
    // this.reqRouterPath();
    // this.getOrderCount();
  },
  methods: {
    tabToPersonalCenter: function() {
      let toWhere = "/personal/set/ins_personal_center/project";
      this.$router.push({ path: toWhere });
    },
    tabToHome: function() {
      let toWhere = "/";
      this.$router.push({ path: toWhere });
    },
    isGetUserInfo: function() {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.checkUserStatus();
      }
    },
    checkUserStatus: function() {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
      } else {
        this.userInfo = {};
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function(userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      // if (dataType == 'string') {
      //   userObj = $.parseJSON(userStore);
      // }

      return userObj;
    },
    getUserInfo: function() {
      let vSelf = this;

      this.$client
        .getUserInfo()
        .then(res => {
          if (res.code === "200" || res === 200) {
            vSelf.userInfo = res.data;
            let curUserInfo = vSelf.saveUserInfo(res.data);
            vSelf.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch(err => {});
    },
    // 保存用户信息
    saveUserInfo: function(userObj) {
      let userInfo;

      userInfo = {
        nickname: userObj.nickname,
        avatar: userObj.avatar,
        is_agents: !regex.isTrueResult(userObj.is_agents),
        is_teacher: regex.isTrueResult(userObj.is_teacher),
        can_view_organ_post: regex.isTrueResult(userObj.can_view_organ_post),
        agents_teacher_max_num: userObj.agents_teacher_max_num,
        agents_teacher_num: userObj.agents_teacher_num,
        invitation_code: userObj.agents_invite_code
      };
      // console.log(JSON.stringify(userInfo));
      return userInfo;
    },
    tabToJumpSubcategory: function(pathName) {
      if (pathName == "course_store") {
        let toWhere = "/mars_box_store/marsbox_store/store";
        this.$router.push({ path: toWhere });
      } else if (pathName == "ins_course") {
        let toWhere =
          "/mars_box_ins/ins_entrance/ins_course_home/ins/ins_course_home";
        this.$router.push({ path: toWhere });
      } else if (pathName == "teacher_forum") {
        let toWhere =
          "/mars_box_ins/ins_entrance/ins_teacher_home/teacherForum/teacherForum";
        this.$router.push({ path: toWhere });
      } else if (pathName == "institutional_management") {
        let toWhere = "/ins_management/management/account_information";
        this.$router.push({ path: toWhere });
      }
      // else if (pathName == 'scratch') {
      //   window.location.href = this.scratchUrl;
      // }
    },
    reqRouterPath: function() {
      this.routerInfo = this.$route.params.isCourseDetail;
    },
    checkAgent: function() {
      if (this.userInfo.is_agents) {
        if (
          !this.headerClass.some(item => item.title == this.agentData.title)
        ) {
          this.headerClass = [...this.headerClass, this.agentData];
        }
      }
    }
  },
  watch: {
    $route: function(from) {
      this.reqRouterPath();
      this.curPosition = this.$route.params.type;
    },
    listenToken: function() {
      let tokenStatus = regex.isTrueResult(this.listenToken);

      if (tokenStatus) {
        this.getUserInfo();
      } else {
        this.logined = false;
      }
    },
    listenUserInfo: function() {
      this.checkUserStatus();
      this.checkAgent();
    }
  }
};
</script>

<style lang="less" scoped>
.ins-header-box {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // min-width: 1400px;
  z-index: 999;
  background: #fff;
  & > div {
    width: 100%;
    height: 60px;
    // align-items: center;
    & > .workstation-box {
      // min-width: 1200px;
      padding-left: 10%;
      padding-right: 18%;
      flex-grow: 1;
      height: 60px;
      // justify-content: space-between;
      align-items: center;
      // padding-right: 160px;
      & > dt {
        // width: 100%;
        // align-items: center;
        padding-right: 54px;
        & > strong {
          display: block;
          // width: 110px;
          // height: 18px;
          width: 150px;
          height: auto;
          // padding-right: 50px;
          cursor: pointer;
          & > img {
            width: 100%;
            // height: 100%;
          }
        }
      }
      & > .forum-page-list {
        width: 100%;
        flex-grow: 1;
        // justify-content: space-between;
        align-items: center;
        & > .page-list {
          width: 100%;
          // flex-grow: 1;
          & > ul {
            width: 100%;
            align-items: center;
            & > .classifacation-font-white {
              white-space: nowrap;
              padding-right: 54px;
              & > strong {
                display: block;
                font-size: 18px;
                color: #191d21;
                font-weight: 500;
                cursor: pointer;
                transition: 0.3s all;
              }
              & > strong:hover {
                color: #ff5100;
              }
            }
            & > .classifacation-font-white-active {
              padding-right: 54px;
              & > strong {
                color: #ff5100;
              }
            }
          }
        }
        & > .user-info {
          width: 130px;
          flex-shrink: 0;
          align-items: center;
          cursor: pointer;
          & > span {
            overflow: hidden;
            display: flex;
            width: 40px;
            height: 40px;
            border-radius: 100%;
            overflow: hidden;
            margin-right: 13px;
            & > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              flex-grow: 1;
            }
          }
          & > h1 {
            display: block;
            font-size: 18px;
            color: #191d21;
            font-weight: 500;
            transition: 0.3s all;
          }
        }
      }
    }
    & > .ins-box {
      padding-left: 10%;
      padding-right: 18%;
      flex-grow: 1;
      height: 60px;
      // justify-content: center;
      align-items: center;
      background: linear-gradient(
        89deg,
        rgba(255, 113, 115, 0.1) 0%,
        rgba(236, 199, 35, 0.1) 100%
      );
      & > dl {
        // min-width: 1200px;
        padding-left: 116px;
        flex-grow: 1;
        height: 60px;
        & > dt {
          width: 100%;
          // flex-grow: 1;
          & > ul {
            align-items: center;
            justify-content: space-between;
            & > li {
              width: 120px;
              height: 58px;
              cursor: pointer;
              transition: all 0.5s;
              border-bottom: 2px solid rgba(0, 0, 0, 0);
              & > span {
                width: 100%;
                & > strong {
                  display: block;
                  font-size: 18px;
                  line-height: auto;
                  color: #191d21;
                  font-weight: 500;
                }
              }
            }
            & > li:hover {
              height: 58px;
              border-bottom: 2px solid #ff5100;
              background: #fff;
            }
            & > .cur-ins-active {
              height: 58px;
              border-bottom: 2px solid #ff5100;
              background: #fff;
            }
          }
        }
        & > .cur-ins-active {
          height: 58px;
          border-bottom: 2px solid #ff5100;
          background: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ins_forum_header_cpn.vue